import { useAuth } from '../context/AuthContext';

export function useFeatureFlags() {
  const { billingSnapshot } = useAuth();
  const features = billingSnapshot?.enabledFeatures;
  return {
    hasFinanceAlerts: features?.includes('FINANCE_ALERTS') ?? false,
    hasPresence: features?.includes('PRESENCE') ?? false,
    hasDeliveryNotes: features?.includes('DELIVERY_NOTES') ?? false,
    hasSmartMatching: features?.includes('DELIVERY_NOTE_SMART_MATCHING') ?? false,
    hasTelegramBot: features?.includes('TELEGRAM_BOT') ?? false,
    hasIntegrations: features?.includes('INTEGRATIONS') ?? false,
    hasPlanning: features?.includes('PLANNING') ?? false,
    hasChecklist: features?.includes('CHECKLIST') ?? false,
  };
}
